import { Component, OnInit, Inject, } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
//ReactiveFormsModule
@Component({
  selector: 'app-search-fascicolo-modal',
  templateUrl: './search-fascicolo-modal.component.html',
  styleUrls: ['./search-fascicolo-modal.component.scss']
})
export class SearchFascicoloModalComponent implements OnInit {

  //public searchFascicoloFormComponent: FormGroup = this.getSearchFascicoloForm();
  public searchFascicoloFormComponent : FormControl = new FormControl(null, Validators.required); //forse migliore se mettiamo solo numeri anche
  public numFascicolo: string;

  ngOnInit() {
  }

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SearchFascicoloModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { header : string, text : string, modalParam:any, numFascicolo:string, desFascicolo : string, searchFascicolo : boolean}) {
      this.numFascicolo = data.numFascicolo;
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onClickSearch(): void {
    this.dialogRef.close(this.searchFascicoloFormComponent.value);
  }

  getSearchFascicoloForm() {
    return this.formBuilder.group({
      numFascicolo: [null, Validators.required],
    });
  }

}
